// extracted by mini-css-extract-plugin
export default {"servicesNmcpLogo":"style_servicesNmcpLogo__fyozj","container":"style_container__0jFt9","headerTextContainer":"style_headerTextContainer__MlsES"};